import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "service-section" }
const _hoisted_2 = { class: "jumbotron jumbotron-fluid bg-1 m-0 mb-3 pb-3" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 text-center mt-5 pt-5" }
const _hoisted_6 = { class: "col-md-12 col-12 text-center" }
const _hoisted_7 = { class: "block-text p-3" }
const _hoisted_8 = { class: "my-4" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "col-md-3 col-12 text-center" }
const _hoisted_11 = { class: "block-text p-3" }
const _hoisted_12 = { class: "my-4" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "col-md-3 col-12 text-center" }
const _hoisted_15 = { class: "block-text p-3" }
const _hoisted_16 = { class: "my-4" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "col-md-3 col-12 text-center" }
const _hoisted_19 = { class: "block-text p-3" }
const _hoisted_20 = { class: "my-4" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "col-md-3 col-12 text-center" }
const _hoisted_23 = { class: "block-text p-3" }
const _hoisted_24 = { class: "my-4" }
const _hoisted_25 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('about_header')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_font_awesome_layers, { class: "fa-4x" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle" }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-book",
                      transform: "shrink-7 left-1",
                      style: { color: 'white' }
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('blueseas_pos_title')), 1),
              _createElementVNode("p", {
                class: "small",
                innerHTML: _ctx.$t('blueseas_pos_description')
              }, null, 8, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_font_awesome_layers, { class: "fa-4x" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle" }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-house",
                      transform: "shrink-7 left-1",
                      style: { color: 'white' }
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('serene_pos_title')), 1),
              _createElementVNode("p", {
                class: "small",
                innerHTML: _ctx.$t('serene_pos_description')
              }, null, 8, _hoisted_13)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_font_awesome_layers, { class: "fa-4x" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle" }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-photo-film",
                      transform: "shrink-8 left-2",
                      style: { color: 'white' }
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('gh_pos_title')), 1),
              _createElementVNode("p", {
                class: "small",
                innerHTML: _ctx.$t('gh_pos_description')
              }, null, 8, _hoisted_17)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_font_awesome_layers, { class: "fa-4x" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle" }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-bed",
                      transform: "shrink-8 left-2",
                      style: { color: 'white' }
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('webconnection_pos_title')), 1),
              _createElementVNode("p", {
                class: "small",
                innerHTML: _ctx.$t('webconnection_pos_description')
              }, null, 8, _hoisted_21)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_font_awesome_layers, { class: "fa-4x" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle" }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-graduation-cap",
                      transform: "shrink-8 left-2",
                      style: { color: 'white' }
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('graduated_title')), 1),
              _createElementVNode("p", {
                class: "small",
                innerHTML: _ctx.$t('graduated_description')
              }, null, 8, _hoisted_25)
            ])
          ])
        ])
      ])
    ])
  ]))
}